import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import { BiLoaderCircle } from "react-icons/bi";
import { FiUploadCloud } from "react-icons/fi";
import axios from "axios";
import { baseURL } from "../../configs/axiosConfig";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { FaCamera } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";

const Uploader = ({ refreshFunction }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  const [isUploading, setIsUploading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [avatar, setAvatar] = useState(null);

  const uploadS3Image = async (file) => {
    if (
      !file ||
      !["image/jpeg", "image/jpg", "image/png"].includes(file.type)
    ) {
      return toast.error("Invalid image format. Only jpg, jpeg, png allowed.");
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${baseURL}/api/products/uploadImageS3`, true);

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100
          );
          setUploadProgress(percentComplete);
        }
      });

      // Handle success
      xhr.onload = async () => {
        setIsUploading(false);
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          if (res.success) {
            setImagePreview(res.location); // Preview image URL from S3 response
            setAvatar(file);
            refreshFunction && refreshFunction(res.location);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Failed to upload image");
          }
        } else {
          toast.error("Failed to upload image");
        }
      };

      // Handle error
      xhr.onerror = () => {
        toast.error("Failed to upload image");
        setIsUploading(false);
      };

      // Send request
      xhr.send(formData);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong");
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatar(file);
    uploadS3Image(file);
  };

  // upload file
  const onDrop = useCallback(async (acceptedFiles) => {
    toast.error("This feature is not available yet");
  }, []);

  return (
    <div className="relative w-[137px] h-[132px] mx-auto">
      <label className="cursor-pointer">
        <input
          type="file"
          name="photo"
          accept="image/jpeg,image/jpg,image/png"
          onChange={handleFileChange}
          className="hidden"
        />
        <div className="w-[132px] h-[132px] rounded-full border-4 border-red-500 overflow-hidden relative">
          <img
            src={
              imagePreview
                ? imagePreview
                : user?.photo || "/images/diamond_logo2.png"
            }
            alt="Avatar"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Camera Icon */}
        <div className="absolute bottom-0 right-0 bg-white rounded-full p-1 shadow-md">
          <FaCamera className="text-gray-600 w-5 h-5" />
        </div>
      </label>

      {user?.isVerified && (
        <div
          className="absolute top-1 right-1 bg-white rounded-full p-1 shadow-md"
          title="Verified User"
        >
          <HiBadgeCheck className="text-green-500" size={18} />
        </div>
      )}

      {isUploading && (
        <div className="absolute top-full mt-2 w-full text-center">
          <div className="w-full bg-gray-200 h-1 rounded overflow-hidden">
            <div
              className="bg-yellow-600 h-full transition-all"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
          <p className="text-xs text-gray-500 mt-1">Uploading...</p>
        </div>
      )}
    </div>
  );
  // <div className="w-full text-center grid grid-cols-12 gap-4">
  //   <label className="px-6 lg:col-span-10 sm:col-span-8 col-span-12 pt-5 pb-6 border-2 border-dashed rounded-md cursor-pointer block text-center">
  //     <input
  //       type="file"
  //       name="photo"
  //       accept="image/jpeg,image/jpg,image/png"
  //       onChange={handleFileChange}
  //       className="hidden"
  //     />
  //     <span className="mx-auto flex justify-center">
  //       <FiUploadCloud className="text-3xl text-yellowdark" />
  //     </span>
  //     <p className="text-sm mt-2">Drag your image here</p>
  //     <em className="text-xs text-gray-400">
  //       (Only *.jpeg and *.png images will be accepted)
  //     </em>
  //   </label>
  //   {/* image preview */}
  //   <div className="lg:col-span-2 sm:col-span-4 col-span-12">
  //     {isUploading ? (
  //       <div className="flex flex-col items-center justify-center h-36 gap-2">
  //         <p>Uploading....</p>
  //         <div className="w-full bg-gray-300 h-1 rounded-md overflow-hidden">
  //           <div
  //             className="h-full bg-yellow-700 transition-all"
  //             style={{ width: `${uploadProgress}%` }}
  //           />
  //         </div>
  //       </div>
  //     ) : (
  //       <img
  //         src={
  //           imagePreview
  //             ? imagePreview
  //             : user && user.photo
  //             ? user.photo
  //             : "/images/diamond_logo2.png"
  //         }
  //         alt="preview"
  //         className="w-36 h-36 rounded-xl object-cover p-1 m-auto"
  //       />
  //     )}
  //   </div>
  // </div>
};

export default Uploader;
